import { render, staticRenderFns } from "./CircleIcon.vue?vue&type=template&id=22f8dbbb"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f8dbbb')) {
      api.createRecord('22f8dbbb', component.options)
    } else {
      api.reload('22f8dbbb', component.options)
    }
    module.hot.accept("./CircleIcon.vue?vue&type=template&id=22f8dbbb", function () {
      api.rerender('22f8dbbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/CircleIcon.vue"
export default component.exports